import axios from 'axios';
import CONFIG from '@/config';
import { getAuthToken } from './utils';

const baseURL = CONFIG.API;

// Create Axios instance
const fdInstance = axios.create({
  baseURL,
  timeout: 30000, // 30 secs
  headers: {
    'Content-Type': 'multipart/form-data'
  }
});

// Request interceptor, optional chaining operator only needed for tests
fdInstance.interceptors.request.use(
  request => {
    const token = getAuthToken();
    request.headers.Authorization = `JWT ${token}`;
    return request;
  },
  error => {
    return Promise.reject(error);
  }
);

// Response interceptor (optional, for error handling), optional chaining operator only needed for tests
fdInstance.interceptors.response.use(
  response => response, // success responses
  error => {
    return Promise.reject(error);
  }
);

export const formDataInstance = fdInstance;
